export enum PAGE_LINK {
    E = '#power-backup-E',
    F = '#power-backup-F',
    G = '#power-backup-G',
    H = '#power-backup-H',
}
const us_ids = {
    [PAGE_LINK.E]: [
        {
            productId: '7290965622857',
            variantId: '41636504305737',
        },
        {
            productId: '7290968473673',
            variantId: '41636514136137',
        },
        {
            productId: '15386067730505',
            variantId: '54691871227977',
        },
        {
            productId: '7289136054345',
            variantId: '41826182496329',
        },
        {
            productId: '7394893463625',
            variantId: '42015827492937',
        },
        {
            productId: '7323318190153',
            variantId: '41719074324553',
        },
    ],
    [PAGE_LINK.F]: [
        {
            productId: '15386147061833',
            variantId: '54718699962441',
        },
        {
            productId: '6905537888329',
            variantId: '40538145095753',
        },
        {
            productId: '15386143096905',
            variantId: '54718705008713',
        },
        {
            productId: '6585086836809',
            variantId: '40516140138569',
        },
        {
            productId: '7185477075017',
            variantId: '41385721004105',
        },
        {
            productId: '7383152951369',
            variantId: '41963472289865',
        },
    ],
    [PAGE_LINK.G]: [
        {
            productId: '15391292588105',
            variantId: '54714781171785',
        },
        {
            productId: '15391292588105',
            variantId: '54714781204553',
        },
        {
            productId: '7185477075017',
            variantId: '41703627980873',
        },
    ],
};

const ca_ids = {
    [PAGE_LINK.E]: [
        {
            productId: '8335910928538',
            variantId: '45166394409114',
        },
        {
            productId: '15039583682931',
            variantId: '52355185279347',
        },
        {
            productId: '15164532916595',
            variantId: '62060639584627',
        },
        // {
        //     productId: '15047267156339',
        //     variantId: '52389663605107',
        // },
        {
            productId: '8331157766298',
            variantId: '51645140926835',
        },
        {
            productId: '7440912384154',
            variantId: '43725896056986',
        },
    ],
    [PAGE_LINK.F]: [
        {
            productId: '15164532654451',
            variantId: '62106661618035',
        },
        {
            productId: '7825964400794',
            variantId: '43592212775066',
        },
        {
            productId: '15164531016051',
            variantId: '62106740556147',
        },
        {
            productId: '6944959824026',
            variantId: '43725958873242',
        },
        // {
        //     productId: '15047267156339',
        //     variantId: '52389663605107',
        // },
        {
            productId: '8231332380826',
            variantId: '44902384599194',
        },
        {
            productId: '8006700236954',
            variantId: '44244774650010',
        },
    ],
    [PAGE_LINK.G]: [
        // {
        //     productId: '8231332380826',
        //     variantId: '44902384599194',
        // },
        {
            productId: '15178584981875',
            variantId: '62111365792115',
        },

        {
            productId: '8231332380826',
            variantId: '52644324901235',
        },

        {
            productId: '8308553515162',
            variantId: '45100148555930',
        },
    ],
};

export const ids = {
    us: us_ids,
    ca: ca_ids,
};
